import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import fcLogoBlack from "@/assets/fc-logo-white.png";

/**
 * Slim sticky header that fades in after the user scrolls past the hero.
 * Visible only on the public Landing page for logged-out users.
 */
export const StickyLandingNav = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0 pointer-events-none"
      }`}
      aria-hidden={!visible}
    >
      <div className="bg-background/90 backdrop-blur border-b border-border">
        <div className="container mx-auto px-6 lg:px-8 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={fcLogoBlack} alt="Focus Casting" className="h-6 w-auto invert" />
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/for-agencies"
              className="hidden sm:inline-flex text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-foreground transition-colors"
            >
              For Agencies
            </Link>
            <Link
              to="/browse"
              className="hidden sm:inline-flex text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-foreground transition-colors"
            >
              Browse Talent
            </Link>
            <Link
              to="/auth?mode=login"
              className="hidden sm:inline-flex text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-foreground transition-colors"
            >
              Log In
            </Link>
            <Link
              to="/auth?mode=signup"
              className="inline-flex items-center bg-primary text-primary-foreground rounded-lg px-4 py-2 text-xs tracking-[0.15em] uppercase hover:bg-primary/90 transition-colors"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
